// Lacunas da petição: o dado que o usuário completa antes de protocolar. O
// formato do Dr. Licita é `[inserir: descrição]`; as teses ainda trazem o
// `[inserir]` puro. A nota de uso é instrução da tese que nunca deveria ir
// para a peça: aparece como alerta. Só exibição: o texto continua texto.

export const LACUNA = /\[inserir(?::[^\]\n]*)?\]/gi;
export const NOTA_DE_USO = /\[nota de uso:[^\]\n]*\]/gi;

const contar = (padrao: RegExp, texto: string): number =>
  (texto.match(new RegExp(padrao.source, padrao.flags)) || []).length;

export const contarLacunas = (markdown: string): number => contar(LACUNA, markdown || '');

export const contarNotasDeUso = (markdown: string): number => contar(NOTA_DE_USO, markdown || '');

export interface Ocorrencia {
  inicio: number;
  fim: number;
  tipo: 'lacuna' | 'nota';
}

// Lacunas e notas de um texto, na ordem em que aparecem
export const ocorrencias = (texto: string): Ocorrencia[] => {
  const achadas: Ocorrencia[] = [];
  const buscar = (padrao: RegExp, tipo: Ocorrencia['tipo']) => {
    const re = new RegExp(padrao.source, padrao.flags);
    let achado = re.exec(texto);
    while (achado !== null) {
      achadas.push({ inicio: achado.index, fim: achado.index + achado[0].length, tipo });
      achado = re.exec(texto);
    }
  };
  buscar(LACUNA, 'lacuna');
  buscar(NOTA_DE_USO, 'nota');
  return achadas.sort((a, b) => a.inicio - b.inicio);
};
